import { render, staticRenderFns } from "./ViewShares.vue?vue&type=template&id=e28a29e2"
import script from "./ViewShares.vue?vue&type=script&lang=js"
export * from "./ViewShares.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports